import * as React from "react";
import { SVGProps } from "react";

const Counterparty = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 1240" {...props}>
    <path
      fill="#ec1550"
      d="M2000 693.32 1708.91 984.6h-276.57a56.76 56.76 0 0 0-56.64 56.64v166a33.34 33.34 0 0 1-33.36 32.76h-211.16a33.34 33.34 0 0 1-33.36-33.36V803.38l172.86-172.85a33.36 33.36 0 0 1 46.36.6l76.3 76.3h200l129-128.91V409.3l-132.16-132.74h-177.8L705.54 983.39H293.6L0 690V294.1L293.91.2h401.75l174.17 174.16a33.42 33.42 0 0 1 0 46.26L721.77 368.18a32.69 32.69 0 0 1-46.06 3.33c-.81-.71-1.61-1.51-2.42-2.22l-92.32-92H408.61L277.08 408.8v166.7L408.2 706.83h182.54L1297.69 0H1705l295 295v398.32Z"
    />
  </svg>
);

export default Counterparty;
